import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path strokeLinejoin="round" d="M8 12h6l3 5v4H7v-7z" />
      <path d="M9 8h4v4H9z" />
      <path strokeLinejoin="round" d="M8 4h7v4H6z" />
      <path d="M16 6h2" />
    </g>
  </svg>
);
